import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class ExpenseService {

    static getExpense(item) {

        let api = `${API_BASE_URL}${API_PATHS.getexpense}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
       
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api,item);
    }

    static addExpense(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addexpense}`;
        return axiosInstance
            .post(api, data)

    }

    static editExpense(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editexpense}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteExpense(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deleteexpense}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default ExpenseService;
